module.exports = __webpack_public_path__ + "static/road_map-e23730a59d28e95583573cc34b05a21a.png";